/*
 * @Descripttion:
 * @version:
 * @Author: gaolongzhi
 * @Date: 2020-04-23 10:19:20
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-09-21 15:04:38
 */
import fetch from '@/apiconfig/index'

let apiList = {
  login: '/api/auth/jwt/employee/token',
  refreshToken: '/api/auth/jwt/refresh',
  forgetPassword: '/api/auth/jwt/employee/forgetPassword/',
  logout: '/api/auth/jwt/invalid',
  getInfo: '/api/admin/user/front/info',
  getTokenByWechatCode: '/api/auth/jwt/employee/getTokenByWechatCode',
  sendSmsCode: '/api/admin/vcc/employeeLoginSms',
  easyRegisterSendSms: '/api/admin/vcc/easyRegisterSendSms',
  mobileValidate: '/api/companystaff/employeeAccount/mobileValidate/',
  updateMobile: '/api/companystaff/employeeAccount/updateMobile',
  sendSms: '/api/admin/vcc/sendSms',
  getTokenByMiniOpenid: '/api/auth/jwt/employee/getTokenByMiniOpenid/',
  setMiniOpenId: '/api/companystaff/employeeAccount/setMiniOpenId/',
  MiniLogout: '/api/companystaff/employeeAccount/miniapp/logout',
  WxLogout: '/api/companystaff/employeeAccount/wechat/logout',
  AppLogout: '/api/companystaff/employeeAccount/app/logout',
  getTokenByAppCode: '/api/auth/jwt/employee/getTokenByAppCode',
  getCustomCompanyInfo:
    '/api/companystaff/employeeAccount/getCustomCompanyInfo', // 获取企业定制化信息

  getDataDictList: '/api/admin/dataDictionary/list',

  userEditPass: '/api/admin/user/partnerEditPass',
  partnetGetActiveUserPartInfo: '/api/admin/user/getActiveUserPartInfo',
  partnetSetHeadshot: '/api/admin/user/setHeadshot',
  list: '/api/admin/area/listArea',

  contentFeedbackPostAction: '/api/content/contentFeedback/saveForUser',
  contentModulelistToActiveUser: '/api/content/contentModule/listToActiveUser',
  contentArticlelistToActiveUser:
    '/api/content/contentArticle/listToActiveUser/',
  contentPosterlistToActiveUser: '/api/content/contentPoster/listToActiveUser/',
  contentPosterlistToNoLoginUser:
    '/api/content/contentPoster/listToNoLoginUser/',

  contractListByActiveUser: '/api/contract/contractEmployee/listByActiveUser', //获得当前登录用户的协议列表
  idImage: '/api/companystaff/employeeAccount/image', //保存身份证正反面照片，base64流 银行卡三要素认证
  idImage2: '/api/companystaff/employeeAccount/image2', //银行卡四要素 运营商三要素认证接口
  reSendAuthCode: '/api/companystaff/employeeAccount/reSendAuthCode', //认证发送手机验证码
  authCodeAudit: '/api/companystaff/employeeAccount/authCodeAudit', //认证
  simpleIdImage: '/api/companystaff/employeeAccount/saveImageAndBankCard', //邀请注册页面保存身份证正反面照片，base64流
  bank: '/api/contract/contractEmployee/bank', //保存员工签署协议绑定银行卡
  contractUrl: '/api/contract/contractEmployee/checkContract', //保存员工签署协议绑定银行卡
  employeeGetAllInfo: '/api/contract/contractEmployee/info/getAllInfo', //获取当前登录用户除了密码外的所有信息外加银行卡信息，签署地址
  createContract: '/api/contract/contractEmployee/createContract', //向e签宝发起协议申请
  individualFace: '/api/companystaff/employeeAccount/indivAuthUrl', //发起刷脸认证
  findIndividualFaceRes:
    '/api/companystaff/employeeAccount/findIndivAuthUrlRes', //查询刷脸认证结果

  /*合作方接口 begin*/
  partnerLogin: '/api/auth/jwt/partnerToken',
  getPartnerTokenByWechatCode:
    '/api/auth/jwt/partner/getPartnerTokenByWechatCode',
  setPartnerOpenIdByCode: '/api/admin/user/setPartnerOpenIdByCode', //用户设置openid
  getCompanyByPartner: '/api/companystaff/ecompanyAgent/getCompanyByPartner',
  getEmolumentByPartner: '/api/emolument/emolument/getEmolumentByPartner',
  getEmolumentTotalByPartner:
    '/api/emolument/emolument/getEmolumentTotalByPartner',
  getCommissionList: '/api/companystaff/commission/page',
  getRechargeList: '/api/companystaff/ecompanyFdIssue/getRechargeList',
  getEcompanyRechargeInfoByecompanyIds:
    '/api/companystaff/ecompanyFdIssue/getEcompanyRechargeInfoByecompanyIds',
  getCommissionDetailList: '/api/companystaff/commissionDetail/page',
  getLastCommission: '/api/companystaff/commission/getLastCommission',
  getCompanyByName: '/api/companystaff/ecompanyAgent/getCompanyByName',
  getAchieve: '/api/companystaff/commission/getAchieve',
  getTrendData: '/api/companystaff/commission/getTrendData',
  refreshPartnerToken: '/api/auth/jwt/refreshPartnerToken', //刷新token过期时间
  applyTicket:
    '/api/companystaff/ecompanyAgent/ecompanyReceipt/fillCompleted/page',
  applySelect: '/api/companystaff/ecompanyAgent/ecompany/select', //要查询服务商下拉列表
  getEcompanyInvoiceTypeById:
    '/api/companystaff/ecompany/getEcompanyInvoiceTypeById', //获取外派公司的开票类型
  applyType: '/api/companystaff/ecompanyAgent/jobCate/selectByEcompanyId',
  applyContent: '/api/companystaff/ecompanyAgent/jobCate/receiptContentByIds',
  getBalace:
    '/api/emolument/partner/receiptRecord/getReceiptAmountByEcompanyId',
  getList: '/api/emolument/partner/emolumentDetail/getCompanyReceiptList',
  getDefaultEcompanyReceipt:
    '/api/companystaff/ecompanyAgent/ecompanyReceipt/getDefaultEcompanyReceipt',
  editSave: '/api/companystaff/ecompanyAgent/ecompanyReceipt/285', // 编辑保存
  addSave: '/api/companystaff/ecompanyAgent/ecompanyReceipt', // 新增保存
  getAccountBalance: '/api/companystaff/ecompanyAgent/getBalanceByecompanyId',
  addReceiptByPartner: '/api/emolument/partner/receipt/addReceiptByPartner', //申请开票
  creditReceiptByPartner:
    '/api/emolument/partner/receipt/creditReceiptByPartner', //授信开票
  getInoiceRecord: '/api/emolument/partner/receipt/page', //开票记录
  getReceiptContent: '/api/admin/dataDictionary/list',
  removeReceipt: '/api/emolument/partner/receipt/removeReceipt',
  receiptTypeGroup: '/api/admin/dataDictionary/list?group=receiptType',
  expressCompanyGroup: '/api/admin/dataDictionary/list?group=logistics',
  /*合作方接口 end*/

  hotTaskList: '/api/contract/taskController/pageByHot', //首页热门任务
  unReadMessage: '/api/message/messageReceiver/hasUnReadMessage', //首页头部维度消息条数
  getEOCompany: '/api/companystaff/employee/listByCurrent', //获取当前登录用户的外包公司和外派公司
  getActiveUserAllInfo:
    '/api/companystaff/employeeAccount/info/getActiveUserAllInfo', //获取当前登录用户除了密码外的所有信息
  newsList: '/api/message/message/userList',
  articleList: '/api/content/contentArticle/pcList',
  getNoticeDetail: '/api/message/message/getMessage/',
  readMessage: '/api/message/messageReceiver/readMessage/',
  bankCardCheck: '/api/companystaff/employeeBankCard/saveCheckUser',
  bankCardSave: '/api/companystaff/employeeBankCard/saveToUser',
  alipaySave: '/api/companystaff/employeeBankCard/saveAlipayToUser',
  alipayEdit: '/api/companystaff/employeeBankCard/editAlipayToUser',
  checkIndividualBusinessStatus:
    '/api/companystaff/employeeAccount/checkIndividualBusinessStatus', //判断个体户认证状态
  checkImage: '/api/companystaff/employeeAccount/checkImage', //上传身份证校验证件号和姓名
  authenticateIdNumber:
    '/api/companystaff/employeeAccount/authenticateIdNumber', //身份认证
  getAuthenticateIdInfo:
    '/api/companystaff/employeeAccount/getAuthenticateIdInfo', //获取文案信息
  authenticateIdFace: '/api/companystaff/employeeAccount/authenticateIdFace', //活体检测
  registerIndividualBusiness:
    '/api/companystaff/employeeAccount/registerIndividualBusiness', //签名个体工商户注册
  getIndividualBusiness:
    '/api/companystaff/individualBusiness/getIndividualBusinessByEmployeeAccountId', //签名个体工商户注册
  getByIndividualBusinessId: '/api/companystaff/individualBusiness/getById', //签名个体工商户注册
  getByIndividualBusinessStatus:
    '/api/companystaff/individualBusiness/checkIndividualBusinessStatus', //个体电签状态
  getAccountIdntityType:
    '/api/companystaff/employeeAccount/getAccountIdntityType', //用户是否同时关联灵工服务商和个体服务商
  updateLastEmployeeMode:
    '/api/companystaff/employeeAccount/updateLastEmployeeMode',
  getPdfUrlByOcompanyId: 'api/companystaff/employee/getPdfUrlByOcompanyId',
  getLogoffText: 'api/companystaff/employeeAccount/getLogoffText',
  uploadLogoffVoide: '/api/companystaff/employeeAccount/uploadLogoffVoide',
  wechatPayToUser: '/api/companystaff/employeeBankCard/saveWechatPayToUser',
  //:'',
  //:'',
  //:'',
  //:'',
  //:'',
  //:'',
  //:'',
  //:'',
  //:'',
}

let list = {}

Object.keys(apiList).forEach((key) => {
  /*
    data 请求参数
    methods：请求方式（axios提供的请求方式：如'get'||'post'||'patch'）
    subUrl: 拼接子url
  */
  list[key] = (data = {}, { method = 'get', subUrl = '' } = {}) => {
    let obj = {
      url: apiList[key] + subUrl,
      method,
    }
    if (method == 'get') {
      obj.params = data
    } else {
      obj.data = data
    }
    return fetch(obj)
  }
})

export { apiList }

export default list
